var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33332 13.3333H11.6667C12.125 13.3333 12.5 12.9583 12.5 12.5V8.33332H13.825C14.5667 8.33332 14.9417 7.43332 14.4167 6.90832L10.5917 3.08332C10.2667 2.75832 9.74166 2.75832 9.41666 3.08332L5.59166 6.90832C5.06666 7.43332 5.43332 8.33332 6.17499 8.33332H7.49999V12.5C7.49999 12.9583 7.87499 13.3333 8.33332 13.3333ZM4.99999 15H15C15.4583 15 15.8333 15.375 15.8333 15.8333C15.8333 16.2917 15.4583 16.6667 15 16.6667H4.99999C4.54166 16.6667 4.16666 16.2917 4.16666 15.8333C4.16666 15.375 4.54166 15 4.99999 15Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon _upload_.2bb470b8896094df855eeba5cd42b637.svg";
export { ForwardRef as ReactComponent };